// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amv5q5gAG_2hQP {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  min-width: 28px;
  height: 24px;
  margin-top: 4px;
  margin-right: 4px;
  padding: 0 5px 0 7px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: 18px;
  /* stylelint-disable-next-line declaration-no-important */
  background-color: var(--ds-background-input, #ffffff) !important;
  color: var(--ds-text-subtle, #44546f);
  font-weight: var(--ds-font-weight-bold, 700);
  cursor: pointer;
}
.amv5q5gAG_2hQP .XixyIRfFRBpsRD {
  font-size: 12px;
  line-height: 1;
  vertical-align: text-bottom;
  pointer-events: none;
}
.amv5q5gAG_2hQP:hover,
.amv5q5gAG_2hQP.KzYqxmV3hBde3Z {
  border: 1px solid var(--ds-border-selected, #0c66e4);
}
.amv5q5gAG_2hQP.KzYqxmV3hBde3Z {
  background: var(--ds-background-selected, #e9f2ff);
}
.amv5q5gAG_2hQP.KzYqxmV3hBde3Z .XixyIRfFRBpsRD {
  color: var(--ds-text-brand, #0c66e4);
}
.amv5q5gAG_2hQP:hover {
  background-color: var(--ds-surface-raised, #ffffff);
}
.amv5q5gAG_2hQP .emoji-mart-emoji {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  font-size: 16px;
  pointer-events: none;
}
.amv5q5gAG_2hQP.GoT3URjehfoOak {
  border: 1px solid var(--ds-border-disabled, #091e420f);
  background-color: transparent;
  pointer-events: none;
}
.amv5q5gAG_2hQP.GoT3URjehfoOak .emoji-mart-emoji {
  opacity: 0.7;
}
.amv5q5gAG_2hQP.GoT3URjehfoOak .XixyIRfFRBpsRD {
  opacity: 0.7;
  color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reaction": `amv5q5gAG_2hQP`,
	"reactionCount": `XixyIRfFRBpsRD`,
	"myReaction": `KzYqxmV3hBde3Z`,
	"disabled": `GoT3URjehfoOak`
};
export default ___CSS_LOADER_EXPORT___;
